import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom'

const root = ReactDOM.createRoot(document.getElementById('root'));
const configuredBasePath = process.env.REACT_APP_BASE_PATH || ''
const basename = configuredBasePath && window.location.pathname.startsWith(configuredBasePath)
  ? configuredBasePath
  : undefined

root.render(
  <React.StrictMode>
    <BrowserRouter basename={basename}>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
